import "./SelectPlan.scss";
import React from "react";
import { PlanI } from "../../../../interfaces/Plans";
import { returnLessonImage } from "../../../../utils/GeneralFunctions";
import { useFormikContext } from "formik";
import LocationByLessonSelect, {
  LocationI,
} from "../../../../components/LocationByLessonSelect/LocationByLessonSelect";

type SelectPlanPropsT = {
  lessons: PlanI[];
  isLoading?: boolean;
  userId?: string | null;
};

interface FormValues {
  selectedPlans: PlanI[];
}

const SelectPlan = ({ lessons, isLoading, userId }: SelectPlanPropsT) => {
  const { setFieldValue, values } = useFormikContext<FormValues>();

  const handlePlan = async (plan: PlanI) => {
    const tempPlans = [...values.selectedPlans];
    const index = tempPlans.findIndex((e) => e.id === plan.id);

    if (index === -1) {
      tempPlans.push({
        ...JSON.parse(JSON.stringify(plan)),
        pricingIndex: 0,
        locationId: "",
      });
    } else {
      tempPlans.splice(index, 1);
    }

    setFieldValue("selectedPlans", tempPlans);
  };

  const handlePricing = async (plan: PlanI, index: number) => {
    const tempPlans = values.selectedPlans.map((p) =>
      p.id === plan.id
        ? {
            ...p,
            pricingIndex: index,
            lessons: { ...JSON.parse(JSON.stringify(plan.lessons)) },
            locationId: p.locationId || "",
          }
        : p
    );
    setFieldValue("selectedPlans", [...tempPlans]);
  };

  const handleLocation = (planId: string, newLocation: LocationI) => {
    const tempPlans = values.selectedPlans.map((p) =>
      p.id === planId ? { ...p, locationId: newLocation.id } : p
    );
    setFieldValue("selectedPlans", tempPlans);
  };

  if (isLoading) {
    return (
      <div className="select-plan-component shadow rounded p-4 bg-white">
        <p className="m-0">Cargando clases para el plan seleccionado...</p>
      </div>
    );
  }

  if (lessons.length === 0) {
    return (
      <div className="select-plan-component shadow rounded p-4 bg-white">
        <p className="m-0">
          No se encontraron clases para el plan seleccionado.
        </p>
      </div>
    );
  }

  return (
    <div className="select-plan-component shadow rounded p-4 bg-white">
      <h2 className="fs-16 mb-2">
        Selecciona los planes que deseas agregar al alumno seleccionado.
      </h2>
      <div className="d-flex flex-column gap-2">
        {lessons.map((plan, i) => {
          const selectedPlanData = values.selectedPlans.find(
            (e) => e.id === plan.id
          );
          return (
            <div className="border-bottom pb-2" key={plan.id}>
              <div className="lesson-item  d-flex flex-column flex-md-row align-items-center p-3 gap-3">
                <div className="lesson-image-container">
                  {returnLessonImage(plan.name)}
                </div>
                <div className="flex-grow-1">
                  <h3 className="fs-14 fw-bolder">{plan.name}</h3>
                </div>
                {values.selectedPlans.findIndex((e) => e.id === plan.id) ===
                -1 ? (
                  <button
                    type="button"
                    className="btn btn-primary fs-14"
                    onClick={() => handlePlan(plan)}
                  >
                    + Agregar
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-danger fs-14"
                    onClick={() => handlePlan(plan)}
                  >
                    - Quitar
                  </button>
                )}
              </div>
              {values.selectedPlans.findIndex((e) => e.id === plan.id) !==
                -1 && (
                <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-2">
                  {plan.lessons.pricing.map((pack, i) => {
                    const isActive =
                      values.selectedPlans.find((e) => e.id === plan.id)
                        ?.pricingIndex === i;
                    return (
                      <div
                        className={`pack-container ${
                          isActive ? "active primary-bg" : ""
                        }`}
                        onClick={() => handlePricing(plan, i)}
                        key={pack.id}
                      >
                        <h4>
                          {pack.reservations === 30
                            ? "Ilimitado"
                            : pack.reservations +
                              (pack.reservations > 1
                                ? " reservas"
                                : " reserva")}
                        </h4>
                        <h5>${pack.cost}</h5>
                      </div>
                    );
                  })}
                </div>
              )}
              {selectedPlanData && (
                <div className="mt-3">
                  <h3 className="mb-1 fs-14 fw-bold">
                    Selecciona la sucursal:
                  </h3>
                  <LocationByLessonSelect
                    locationId={selectedPlanData.locationId || ""}
                    handleChange={(location) =>
                      handleLocation(plan.id, location)
                    }
                    id={plan.id}
                    lessonId={plan.lessons.id}
                    userId={userId}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SelectPlan;
